
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/hosting",
      function () {
        return require("private-next-pages/dashboard/hosting/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/hosting"])
      });
    }
  